<template>
    <div>
        <!-- 添加编辑弹窗 -->
        <el-dialog class="dialog-box" :title="title" :visible.sync="formDialog" :close-on-click-modal="false" width="500px">
            <!-- <el-scrollbar wrap-class="scrollbar-wrapper"> -->
                <el-form :model="formData" :rules="rulesForm" ref="ruleForm" label-width="150px" v-if="formDialog">
                    <!-- 是否合作 -->
                    <el-form-item class="form-item form-inline-item" label="是否合作" prop="type">
                        <el-select v-model="formData.isCooperate" placeholder="请选择" style="width:240px" clearable>
                            <el-option v-for="item in isCooperateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                   
                        <!-- 标签名称 -->
                    <el-form-item class="form-item form-inline-item" label="标签名称" prop="name">
                        <el-input v-model="formData.name" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>
                    <!-- 标签类型 -->
                    <el-form-item class="form-item form-inline-item" label="标签类型" prop="type">
                        <el-select v-model="formData.type" placeholder="请选择" style="width:240px" clearable>
                            <el-option v-for="item in typesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    

                </el-form>
            <!-- </el-scrollbar> -->

            <div slot="footer" class="dialog-footer">
                <div class="right-box">
                    <el-button class="button-primary-plain" size="small" @click="formDialog = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="handleSave">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 批量上传弹窗 -->
        <batch-upload ref="batch"></batch-upload>

    </div>
   
</template>

<script>
import BatchUpload from './batchUpload.vue'
import { outsource_saveOutsourcer} from "@File~/api/outsourcing";

export default {
    components:{BatchUpload},
    data() {
        return {
            source:'',
            formDialog: false,
            title: '',
            formData: {
                "id":null,
                "name":"",
                "type":'',
            },
            rulesForm:{
                type: [{ required: true, message: '请选择标签类型', trigger: 'blur' }],
                name: [{ required: true, message: '请输入标签名称', trigger: 'change' }],
                isCooperate: [{ required: true, message: '请选择是否合作', trigger: 'change' }],
                positionType: [{ required: true, message: '请选择岗位分类', trigger: 'change' }],
                isNewAgreement: [{ required: true, message: '请选择是否已签新外包协议', trigger: 'change' }],
            },
            //新增属性
            postTypeOptions:[],
            isNewCollaboratorsOptions:[],
            isNewContractOptions:[{id:'1',name:'是'},{id:'-1',name:'否'}],
            styleLabelsOptions: [],
            technologysOptions: [],
            gradesOptions: [],
            projectOptions: [],
            typesOptions: [],
            isCooperateOptions: [],
            companySizeOptions: [{name:'1-100人'},{name:'101-500人'},{name:'501-1000人'},{name:'1001-3000人'},{name:'3001-5000人'},{name:'5000+人'},],
            isHeroCollaboratorsOptions: [{id:'1',name:'是'},{id:'-1',name:'否'}],

            rateOptions:[]
        }
    },
    methods: {
        changeCollaborator(){
            if(this.formData.isHeroCollaborator != 1){
                this.formData.heroProject = []
            }
        },
        // 初始化
        init(source,initData,row){
            this.source = source
            if(source == 'add') {
                this.title = '新增标签'
                this.formData = {
                    "id":null,
                    "inListTimeStr":"",
                    "type":'',
                    "positionType":[],
                    "grade":'',
                    "name":"",
                    "website":"",
                    "address":"",
                    "telephone":"",
                    "worksUrl":"",
                    "companySize":"",
                    "employeeComposition":"",
                    "styleLabel":[],
                    "technology":[],
                    "isHeroCollaborator":"",
                    "heroProject":[],
                    "attendedProject":"",
                    "totalScore":"" ,
                    "materialUrl":"" ,
                }
            } else {
                this.title = '编辑标签'
            }
            this.styleLabelsOptions = initData.styleLabelsOptions
            this.technologysOptions = initData.technologysOptions
            this.gradesOptions = initData.gradesOptions
            this.typesOptions = initData.typesOptions
            this.isCooperateOptions = initData.isCooperateOptions
            //新增岗位，是否已签新外包协议
            this.postTypeOptions = initData.postTypeOptions
            this.isNewCollaboratorsOptions = initData.isNewCollaboratorsOptions
            this.isHeroCollaboratorsOptions = initData.isHeroCollaboratorsOptions
            this.projectOptions = initData.projectOptions
        
            if(row){
                this.formData = JSON.parse(JSON.stringify(row));
                delete this.formData.modifyTime;
                this.formData.isHeroCollaborator +='';
                this.formData.type = this.formData.type?this.formData.type*1:'';
                this.formData.isCooperate = this.formData.isCooperate?this.formData.isCooperate*1:'';
                this.formData.positionType = this.formData.positionType?this.formData.positionType.split(',').map((item)=>{return parseInt(item)}):[];
                this.formData.isNewAgreement = this.formData.isNewAgreement?this.formData.isNewAgreement*1:'';
                this.formData.grade = this.formData.grade?this.formData.grade*1:'';
                this.formData.heroProject = this.formData.heroProject?this.formData.heroProject.split(',').map((item)=>{return parseInt(item)}):[];
                this.formData.styleLabel = this.formData.styleLabel?this.formData.styleLabel.split(',').map((item)=>{return parseInt(item)}):[];
                this.formData.technology = this.formData.technology?this.formData.technology.split(',').map((item)=>{return parseInt(item)}):[];
            }
            // this.formData = row?row:null
            // this.getProject()
            this.formDialog = true
        },
        

        updataFun(){
            let param = JSON.parse(JSON.stringify(this.formData));
            param.heroProject = param.heroProject.join(',')
            param.styleLabel = param.styleLabel.join(',')
            param.technology = param.technology.join(',')
            param.positionType = param.positionType.join(',')
        
            //  outsource_saveOutsourcer(param).then((response) => {
            //      if(response.code == 1){
            //          this.$parent.handleFilter()
            //          this.$message({type:'success',message:'保存成功'})
            //          this.formDialog = false;
            //      }
            //  })
        },
    
        // 确定
        handleSave() {

            this.$refs.ruleForm.validate((valid) => {
                if(valid) {
                    this.updataFun()
                }
            })
        },

        // 批量上传
        handleBatchUpload() {
            this.$refs['batch'].init()
        }
    }
}
</script>

<style lang="scss" scoped>
    // 弹窗
.dialog-box {
  ::v-deep .el-dialog{
    height: 350px;
    background: #FFFFFF;
    border-radius: 4px;
  }
  ::v-deep .el-dialog__header{
    padding: 26px 32px 24px;
  }
  ::v-deep .el-dialog__title{
    font-weight: 500;
    color: #333333;
  }
  ::v-deep .el-dialog__headerbtn{
    top: 18px;
    right: 28px;
    font-size: 24px;
  }
  ::v-deep .el-dialog__body{
    overflow: auto;
    padding: 16px 10px 16px 20px;
  }

  ::v-deep .el-scrollbar {
    //padding-right: 22px;
    height: 100%;
  }
  ::v-deep .el-scrollbar__wrap{
    overflow-x: auto;
  }

  ::v-deep .el-scrollbar__bar.is-vertical {
      right: 0px;
  }

  ::v-deep .el-form{
    margin-right: 16px;
    display: flex;
    flex-flow: row wrap;
    // justify-content: space-around;
  }
  .form-item{
    // margin-left:10px;
    // margin-right: 10px;
    .el-form-item__label{
      color: #666666;
      font-weight: 400;
    }
    .el-input__inner{
      background: #FFFFFF;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      border: 1px solid #E5E5E5;
      color: #333333;
    }
    .el-icon-arrow-up:before {
        content: "\E78F";
        color: #666;
    }
  }

  .dialog-footer{
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    padding: 0 32px 24px;

    .button-primary-plain{
      border: 1px solid #3A89FF;
      background: #FFFFFF;
      color: #3A89FF;
    }
    .el-button{
      font-size: 14px;
      padding: 11px 17px;
      border-radius: 4px;
    }
    .el-message-box__btns button:nth-child(2){
      margin-left: 12px;
    }

    .button_span{
      margin-left: 4px;
    }
    .left-box{
      float: left;
    }
    .right-box{
      float: right;
    }
  }

}

</style>

